<script lang="ts">
  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import Checkbox from "../../atoms/forms/Checkbox.svelte";
  import BlueButton from "../BlueButton.svelte";
  import RedButton from "../RedButton.svelte";
  import Annotation from "../../atoms/Annotation.svelte";
  import { ErrorService } from "../../services/error.service";

  export let handleLabel;
  export let handleOrder = (event) => {
    ErrorService.unimplemented();
  };
  export let handleDisabled = (event) => {
    ErrorService.unimplemented();
  };
  export let save;
  export let remove;
  export let model;
  export let loading;
  export let max = undefined;
  export let hasOrder = true;
  export let hasDisabled = true;
  export let disabled = false;
</script>

<div>
  <h3 class="font-semibold">項目詳細</h3>

  <div class="mt-6">
    <FormWithLabel
      label="表示名"
      input={handleLabel}
      value={model.label || model.name || ""}
    />
  </div>

  {#if hasOrder}
    <div class="mt-6">
      <FormWithLabel
        label="表示順"
        input={handleOrder}
        value={`${model.order}`}
        inputType="number"
        min="1"
        {max}
      />
    </div>
  {/if}

  <slot />

  {#if hasDisabled}
    <div class="mt-6">
      <Checkbox
        label="表示する"
        on:click={handleDisabled}
        checked={!model.disabled}
      />
    </div>
    <Annotation>
      選択肢として表示するにはチェックを入れたままにしてください。
    </Annotation>
  {/if}

  <BlueButton rounded klass="mt-4" click={save} {loading} {disabled}>
    更新する
  </BlueButton>

  <RedButton rounded klass="mt-4 ml-2" click={remove} {loading}>
    削除する
  </RedButton>
</div>
